'use strict';

var jsxRuntime = require('react/jsx-runtime');

const LargeBubble = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3.30005C6.72267 3.30005 2.30005 7.11994 2.30005 12C2.30005 16.8802 6.72267 20.7001 12 20.7001C13.928 20.7001 15.7303 20.1953 17.2464 19.3199L20.1822 20.0595C20.4237 20.1203 20.6793 20.0483 20.8535 19.8703C21.0276 19.6923 21.0942 19.4352 21.0282 19.1951L20.2922 16.518C21.1825 15.2055 21.7001 13.6587 21.7001 12C21.7001 7.11994 17.2774 3.30005 12 3.30005ZM8.05718 13.16783C8.71893 13.16783 9.25718 12.6295 9.25718 11.9685C9.25718 11.3075 8.71893 10.76917 8.05718 10.76917C7.39543 10.76917 6.85718 11.3075 6.85718 11.9685C6.85718 12.6295 7.39543 13.16783 8.05718 13.16783ZM13.4 11.9685C13.4 12.6295 12.8618 13.16783 12.2 13.16783C11.5383 13.16783 11 12.6295 11 11.9685C11 11.3075 11.5383 10.76917 12.2 10.76917C12.8618 10.76917 13.4 11.3075 13.4 11.9685ZM16.2 13.16783C16.8618 13.16783 17.4 12.6295 17.4 11.9685C17.4 11.3075 16.8618 10.76917 16.2 10.76917C15.5383 10.76917 15 11.3075 15 11.9685C15 12.6295 15.5383 13.16783 16.2 13.16783Z",
            fill: "currentColor"
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    d: "M19.5294 16.3842L18.9663 15.9683C18.8388 16.141 18.7975 16.3627 18.8544 16.5697L19.5294 16.3842ZM17.1361 18.5702L17.3071 17.8914C17.1235 17.8452 16.9289 17.8753 16.7678 17.975L17.1361 18.5702ZM20.3532 19.3806L20.1822 20.0594C20.4236 20.1203 20.6792 20.0482 20.8534 19.8703C21.0276 19.6923 21.0941 19.4352 21.0281 19.1951L20.3532 19.3806ZM20.3 12C20.3 13.4583 19.8137 14.8208 18.9663 15.9683L20.0925 16.8C21.1047 15.4293 21.7 13.779 21.7 12H20.3ZM12 4.7C16.6638 4.7 20.3 8.04355 20.3 12H21.7C21.7 7.11989 17.2774 3.3 12 3.3V4.7ZM3.7 12C3.7 8.04355 7.33625 4.7 12 4.7V3.3C6.72262 3.3 2.3 7.11989 2.3 12H3.7ZM12 19.3C7.33625 19.3 3.7 15.9564 3.7 12H2.3C2.3 16.8801 6.72262 20.7 12 20.7V19.3ZM16.7678 17.975C15.4226 18.8074 13.7799 19.3 12 19.3V20.7C14.0386 20.7 15.9367 20.1357 17.5045 19.1655L16.7678 17.975ZM16.9652 19.249L20.1822 20.0594L20.5241 18.7018L17.3071 17.8914L16.9652 19.249ZM21.0281 19.1951L20.2044 16.1986L18.8544 16.5697L19.6782 19.5662L21.0281 19.1951Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("ellipse", {
                    cx: "8.05718",
                    cy: "11.9685",
                    rx: "1.2",
                    ry: "1.19933",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("ellipse", {
                    cx: "12.2",
                    cy: "11.9685",
                    rx: "1.2",
                    ry: "1.19933",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("ellipse", {
                    cx: "16.2",
                    cy: "11.9685",
                    rx: "1.2",
                    ry: "1.19933",
                    fill: "currentColor"
                })
            ]
        })
    });
};

module.exports = LargeBubble;
